import { collectionConstants } from '../../_constants';
import { collectionServices } from '../../_services';
import { alertActions, userActions } from '../index';
import { confirmPromptActions } from '../confirmPromptActions';

export const collectionActions = {
    resetCollection,

    // GET
    getWaybillRefforCollection,
    waybillforCollectionOtherCharges,
    loadAllCreatedCollection,
    getCollectionId,
    getCollectionIdOtherCharge,

    // POST
    createCollection,

    // PUT
    updateCollection,

    // DELETE
    deleteCollection,

    // OTHER
    calculateCwt,
    excessPaymentSetting,
    otherIncomeAccounts,
    generateReceiptNo,
}

function resetCollection() { return { type: collectionConstants.RESET } }

function collectionFetching() { return { type: collectionConstants.COLLECTION_FETCHING } }
function collectionFetched() { return { type: collectionConstants.COLLECTION_FETCHED } }

function collectionSubmitting() { return { type: collectionConstants.COLLECTION_SUBMITTING } }
function collectionSubmitted() { return { type: collectionConstants.COLLECTION_SUBMITTED } }

function otherIncomeAccounts(search) {
    return dispatch => {
        // dispatch(collectionFetching());
        collectionServices.otherIncomeAccounts(search)
            .then(
                OtherInAcct => {
                    if(OtherInAcct && OtherInAcct.length){
                        dispatch(collectionFetched());
                        dispatch(success(OtherInAcct));
                    }
                },
                error => {
                    dispatch(collectionFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(OtherInAcct) { return { type: collectionConstants.OTHER_INCOME_ACCOUNT, OtherInAcct } }
}

function excessPaymentSetting(search) {
    return dispatch => {
        // dispatch(collectionFetching());
        collectionServices.excessPaymentSetting(search)
            .then(
                excessPayGL => {
                    if(excessPayGL && excessPayGL.length){
                        dispatch(collectionFetched());
                        dispatch(success(excessPayGL));
                    }
                },
                error => {
                    dispatch(collectionFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(excessPayGL) { return { type: collectionConstants.EXCESS_PAY_GL, excessPayGL } }
}

function getWaybillRefforCollection(payload) {
    return dispatch => {
        dispatch(collectionFetching());
        collectionServices.getWaybillRefforCollection(payload)
            .then(
                wbCollection => {
                    if(!wbCollection.message){
                        dispatch(collectionFetched());
                        dispatch(success(wbCollection));
                    }
                    else{
                        dispatch(collectionFetched());
                        dispatch(alertActions.warning(wbCollection.message));
                    }
                },
                error => {
                    dispatch(collectionFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(wbCollection) { return { type: collectionConstants.GET_WAYBILL_FOR_COLLECTION, wbCollection } }
}

function waybillforCollectionOtherCharges(payload) {
    return dispatch => {
        // dispatch(collectionFetching());
        collectionServices.waybillforCollectionOtherCharges(payload)
            .then(
                wbCollectionOther => {
                    if(!wbCollectionOther.message){
                        // dispatch(collectionFetched());
                        dispatch(success(wbCollectionOther));
                    }
                    else{
                        // dispatch(collectionFetched());
                        dispatch(alertActions.warning(wbCollectionOther.message));
                    }
                },
                error => {
                    dispatch(collectionFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(wbCollectionOther) { return { type: collectionConstants.GET_WAYBILL_FOR_COLLECTION_OTHER_CHARGE, wbCollectionOther } }
}

function loadAllCreatedCollection(payload) {
    return dispatch => {
        dispatch(collectionFetching());
        dispatch(userActions.allowLeavePage());
        collectionServices.loadAllCreatedCollection(payload)
            .then(
                collectionDatas => {
                    if(!collectionDatas.message){
                        dispatch(collectionFetched());
                        dispatch(success(collectionDatas));
                    }
                    else{
                        dispatch(collectionFetched());
                        dispatch(alertActions.warning(collectionDatas.message));
                    }

                },
                error => {
                    dispatch(collectionFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(collectionDatas) { return { type: collectionConstants.LOAD_COLLECTION, collectionDatas } }
}

function getCollectionId(payload) {
    return dispatch => {
        dispatch(collectionFetching());
        collectionServices.getCollectionId(payload)
            .then(
                collectionById => {
                    dispatch(collectionFetched());
                    dispatch(success(collectionById));
                },
                error => {
                    dispatch(collectionFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(collectionById) { return { type: collectionConstants.GET_COLLECTION_BY_ID, collectionById } }
}

function getCollectionIdOtherCharge(payload) {
    return dispatch => {
        dispatch(collectionFetching());
        collectionServices.getCollectionIdOtherCharge(payload)
            .then(
                collectionByIdOtherCharge => {
                    dispatch(collectionFetched());
                    dispatch(success(collectionByIdOtherCharge));
                },
                error => {
                    dispatch(collectionFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(collectionByIdOtherCharge) { return { type: collectionConstants.GET_COLLECTION_BY_ID_OTHERCHARGE, collectionByIdOtherCharge } }
}

function createCollection(payload) {
    return dispatch => {
        dispatch(collectionSubmitting());
        dispatch(userActions.notallowLeavePage());
        collectionServices.createCollection(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(collectionSubmitted());
                    dispatch(alertActions.success('Collection Successfully Created'));
                    window.location.href = '/CROAccounting/CollectionAtDAT';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    // console.log('error', error)
                    dispatch(collectionSubmitted());
                     if(error.message){ dispatch(alertActions.error(error.message));}
                    else if(error.Message){ dispatch(alertActions.error(error.Message));}
                    else{ dispatch(alertActions.error(error));}
                }
            )
    }
}

function updateCollection(payload) {
    return dispatch => {
        dispatch(collectionSubmitting());
        dispatch(userActions.notallowLeavePage());
        collectionServices.updateCollection(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(collectionSubmitted());
                    dispatch(alertActions.success(success.message));
                    window.location.href = '/CROAccounting/CollectionAtDAT';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(collectionSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

function deleteCollection(selected, userId, isViewer) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        collectionServices.deleteCollection(selected)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(loadAllCreatedCollection(userId, isViewer));
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Collection Deleted Successfully.'));
                    setTimeout(() => {
                        window.location.href = '/CROAccounting/CollectionAtDAT';                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function calculateCwt(data) {
    return dispatch => {
        // dispatch(collectionFetching());
        collectionServices.calculateCwt(data)
            .then(
                calculatedCwt => {
                        // dispatch(collectionFetched());
                        dispatch(success(calculatedCwt));
                },
                error => {
                    // dispatch(collectionFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(calculatedCwt) { return { type: collectionConstants.CALCULATED_CWT, calculatedCwt } }
}

function generateReceiptNo(data) {
    return dispatch => {
        collectionServices.generateReceiptNo(data)
            .then(
                generatedReceipt => {
                    dispatch(success(generatedReceipt));
                },
                error => {
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(generatedReceipt) { return { type: collectionConstants.GENERATE_RECEIPT, generatedReceipt } }
}